import { post } from "../utils/rest";
import SERVICE from "./constants";

export class ReceiptScanError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ReceiptScanError";
  }
}

export default class ReceiptScanAPI {
  private authHeaders: Record<string, string>;

  constructor(user: { secretGUID: string; userId: string }, businessId?: string) {
    const resolvedBusinessId = businessId || process.env.GATSBY_BUSINESS_ID!;
    this.authHeaders = {
      SESSION_ID: user.secretGUID,
      BUSINESS_ID: resolvedBusinessId,
      USER_ID: user.userId,
    };
  }

  lookupReceipt(locationId: string, orderId: string, checkId: string, recaptchaToken?: string) {
    return this.postWithValidation("lookupReceipt", { locationId, orderId, checkId, recaptchaToken }, "Receipt lookup failed");
  }

  accruePoints(locationId: string, orderId: string, checkId: string, recaptchaToken?: string) {
    return this.postWithValidation("scanReceiptForPoints", { locationId, orderId, checkId, recaptchaToken }, "Receipt scan failed");
  }

  private postWithValidation(path: string, body: Record<string, unknown>, fallbackMessage: string) {
    return post(
      `${SERVICE.RECEIPT_SCAN}/${path}`,
      body,
      this.authHeaders,
    ).then((data: any) => {
      if (!data || data.success === false) {
        throw new ReceiptScanError((data && data.message) || fallbackMessage);
      }
      return data;
    });
  }
}
